import {default as VtxGrid} from './VtxGrid';
import {default as VtxModeGrid} from './VtxModeGrid';

VtxGrid.VtxModeGrid = VtxModeGrid;

export default VtxGrid;
export {VtxGrid,VtxModeGrid};